import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SectionWrapper from '../../components/marketing/SectionWrapper';

export default function TermsPage() {
  const { t } = useTranslation();

  return (
    <>
      <section className="pt-24 pb-14 bg-gradient-to-br from-cyan-50/60 via-white to-teal-50/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 tracking-tight">{t('footer.terms')}</h1>
          </motion.div>
        </div>
      </section>

      <SectionWrapper background="white">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="max-w-3xl mx-auto prose prose-gray prose-sm md:prose-base"
          dir="rtl"
        >
          <p className="text-gray-500 text-sm mb-6">עודכן לאחרונה: מרץ 2026</p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">1. הגדרות</h2>
          <p className="text-gray-600 leading-relaxed">
            "השירות" — מערכת קיפיקיד לניהול גני ילדים, הכוללת אתר אינטרנט, אפליקציה להורים ואפליקציית טאבלט לצוות הגן.
            "המשתמש" — כל אדם הנרשם לשירות או משתמש בו, לרבות הורים, גננות, מנהלי רשתות ורשויות.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">2. תנאי שימוש כלליים</h2>
          <p className="text-gray-600 leading-relaxed">
            השימוש בשירות מותנה בקבלת תנאים אלו. המשתמש מתחייב לעשות שימוש חוקי בלבד בשירות,
            לא להעלות תכנים פוגעניים ולשמור על סודיות פרטי הגישה שלו.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">3. רישום ואבטחת חשבון</h2>
          <p className="text-gray-600 leading-relaxed">
            המשתמש אחראי לשמירה על סודיות הסיסמה שלו ולכל פעילות המתבצעת תחת חשבונו.
            יש לדווח מיידית על כל שימוש לא מורשה בחשבון.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">4. קניין רוחני</h2>
          <p className="text-gray-600 leading-relaxed">
            כל הזכויות בשירות, לרבות עיצוב, קוד, תוכן וסימני מסחר שייכים לחברה.
            אין להעתיק, לשכפל או להפיץ חלקים מהשירות ללא אישור מראש ובכתב.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">5. הגבלת אחריות</h2>
          <p className="text-gray-600 leading-relaxed">
            השירות ניתן "כמות שהוא" (AS IS). החברה עושה מאמצים סבירים לשמור על זמינות ואמינות השירות,
            אך אינה אחראית לנזקים הנובעים מהפסקות זמניות, תקלות טכניות או שימוש לא נאות.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">6. ביטול והפסקת שימוש</h2>
          <p className="text-gray-600 leading-relaxed">
            החברה רשאית להשעות או לבטל גישה של משתמש שמפר תנאים אלו.
            משתמש רשאי לבקש ביטול חשבונו בכל עת באמצעות פנייה לשירות הלקוחות.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">7. יצירת קשר</h2>
          <p className="text-gray-600 leading-relaxed">
            לשאלות בנוגע לתנאי השימוש ניתן לפנות אלינו בדוא"ל: info@kipikid.com או בטלפון: 050-5774499.
          </p>
        </motion.div>
      </SectionWrapper>
    </>
  );
}
